import React, { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import RenderIf from '@/components/Common/RenderIf';

interface Props {
  children: ReactNode;
  afterTitle?: ReactNode;
  title?: string;
  className?: string;
  titleClass?: string
}
const CheckoutV2Card: FC<Props> = ({ children, title, className, afterTitle, titleClass }) => {
  const cardClass = ' p-4 bg-grayZl-950 rounded-[12px]';
  const cardTitleClass = ' text-base text-white font-medium mb-4';
  const cardChildClassName = ' space-y-4';
  return (
    <div className={twMerge(' ', cardClass, className)}>
      <RenderIf condition={Boolean(title)}>
        <div className={titleClass}>
          <h2 className={cardTitleClass}>{title}</h2>
          <RenderIf condition={!!afterTitle}>{afterTitle}</RenderIf>
        </div>
      </RenderIf>
      <div className={cardChildClassName}>{children}</div>
    </div>
  );
};

export default CheckoutV2Card;
